import * as React from 'react';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';
import { Moment } from 'moment';

import DatePickerSingle from 'components/date-picker/date-picker-single/DatePickerSingleLazy';
import { FormField } from 'components/form';
import Tooltip from 'components/Tooltip';

import { handleGoLiveDateChange } from '../../redux/actions';

import { __t } from 'utils/language';
import { isRequired } from 'utils/validators';
import {
  getInitialVisibleMonth,
  isDayBlocked
} from '../../../../utils/date-picker';

import type {
  CcmCampaignFormCreatorlessThunkDispatch as Dispatch,
  StateAsPartOfGlobal
} from '../../types';

type OwnProps = {
  initialDate: null | string,
  disabled: boolean,
  mgsKey: string,
  classNameBase: string
};

type StateProps = {
  goLiveDate: null | string
};

type DispatchProps = {
  onChangeDate: (d: string) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const GoLiveDate = ({
  initialDate,
  disabled,
  mgsKey,
  classNameBase,
  goLiveDate,
  onChangeDate
}: Props): JSX.Element => (
  <FormField
    showRequiredMark
    showValidationIcon={false}
    fontSize="small"
    label={__t(`${mgsKey}.go_live.label`)}
    sublabel={__t(`${mgsKey}.go_live.sublabel`)}
    labelType="highlighted"
    direction="column"
    validators={[
      isRequired(goLiveDate)
    ]}
  >
    <div className={`${classNameBase}__go-live-date`}>
      <div className={`${classNameBase}__go-live-date-label`}>
        {__t(`${mgsKey}.go_live.go_live_date_label`)}
      </div>
      {
        disabled ? (
          <Tooltip
            message={__t(`${mgsKey}.tooltips.cannot_edit_go_live_date`)}
          >
            <DatePickerSingle
              name="date"
              date={goLiveDate}
              disabled={disabled}
              onChange={() => undefined}
            />
          </Tooltip>
        ) : (
          <DatePickerSingle
            name="date"
            date={goLiveDate}
            disabled={disabled}
            isDayBlocked={(day: Moment) => isDayBlocked(
              day,
              initialDate
            )}
            initialVisibleMonth={() => getInitialVisibleMonth(
              initialDate
            )}
            onChange={date => {
              if (isNil(date)) {
                return;
              }

              onChangeDate(date);
            }}
          />
        )
      }
    </div>
  </FormField>
);

const mapStateToProps = ({ ccmCampaignFormCreatorless }: StateAsPartOfGlobal): StateProps => ({
  goLiveDate: ccmCampaignFormCreatorless.form.goLiveDate
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onChangeDate: date => dispatch(handleGoLiveDateChange(date))
});

export default connect(mapStateToProps, mapDispatchToProps)(GoLiveDate);
